<template>
  <div id="app-div" style="overflow-y: hidden">
    <a-tabs defaultActiveKey="1" @change="tabChange">
      <a-tab-pane tab="按年份统计" key="1">
        <div class="top">
          <div class="search_icon">
            <span style="margin-left: 10px">
              <img src="../../../assets/u3220.png" class="icon_img" />
              筛选查询
            </span>
          </div>
          <div class="query_div">
            <a-row>
              <a-col :span="5">
                <label>年份：</label>
                <a-input
                  placeholder="请输入"
                  v-model="yearLeft"
                  style="width: 100px"
                />
                <label style="padding: 10px">-</label>
                <a-input
                  placeholder="请输入"
                  v-model="yearRight"
                  style="width: 100px"
                />
              </a-col>
              <a-button type="primary" class="query_btn" @click="query"
                >查询</a-button
              >
            </a-row>
          </div>
        </div>
        <div class="middle">
          <div style="float: left; margin-left: 10px">
            <img src="../../../assets/u3227.png" class="icon_img" />
            <span>&nbsp;数据列表</span>
          </div>
        </div>
        <div class="bottom" id="bottom">
          <template>
            <div class="table_box">
              <a-table
                :pagination="false"
                :rowSelection="rowSelection"
                :columns="editorialcolumns"
                :dataSource="data"
                :rowKey="(record) => record.uId"
                size="small"
                :scroll="{ y: data.length < 8 ? false : table_height }"
                bordered
              ></a-table>
            </div>
            <div id="components-pagination-demo-mini">
              <a-pagination
                :total="total"
                :showTotal="(total) => `共 ${total} 条`"
                showSizeChanger
                showQuickJumper
                :pageSizeOptions="pageSizeOptions"
                :defaultPageSize="limit"
                @showSizeChange="onShowSizeChange"
                @change="pageChange"
              />
            </div>
          </template>
          <a-select
            defaultValue="0"
            class="batch_operation"
            @change="operateChange"
            v-model="operateCode"
          >
            <a-select-option value="0">批量操作</a-select-option>
            <a-select-option value="1">批量导出</a-select-option>
          </a-select>
        </div>
      </a-tab-pane>
      <a-tab-pane tab="按期次统计" key="2" forceRender>
        <div class="top">
          <div class="search_icon">
            <span style="margin-left: 10px">
              <img src="../../../assets/u3220.png" class="icon_img" />
              筛选查询
            </span>
          </div>
          <div class="query_div">
            <a-row>
              <a-col :span="5">
                <label>年份：</label>
                <a-input
                  placeholder="请输入"
                  v-model="year"
                  style="width: 100px"
                />
              </a-col>
              <a-button type="primary" class="query_btn" @click="query"
                >查询</a-button
              >
            </a-row>
          </div>
        </div>
        <div class="middle">
          <div style="float: left; margin-left: 10px">
            <img src="../../../assets/u3227.png" class="icon_img" />
            <span>&nbsp;数据列表</span>
          </div>
        </div>
        <div class="bottom" id="bottom2">
          <template>
            <div class="table_box">
              <a-table
                :pagination="false"
                :rowSelection="rowSelection"
                :columns="yearcolumns"
                :dataSource="data"
                :rowKey="(record) => record.uId"
                size="small"
                :scroll="{ y: data.length < 8 ? false : table_height }"
                bordered
              ></a-table>
            </div>
            <div id="components-pagination-demo-mini">
              <a-pagination
                :total="total"
                :showTotal="(total) => `共 ${total} 条`"
                showSizeChanger
                showQuickJumper
                :pageSizeOptions="pageSizeOptions"
                :defaultPageSize="limit"
                @showSizeChange="onShowSizeChange"
                @change="pageChange"
              />
            </div>
          </template>
          <a-select
            defaultValue="0"
            class="batch_operation"
            @change="operateChange"
            v-model="operateCode"
          >
            <a-select-option value="0">批量操作</a-select-option>
            <a-select-option value="1">批量导出</a-select-option>
          </a-select>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
const editorialcolumns = [
  {
    title: "年份",
    dataIndex: "year",
    align: "center",
    sorter: (a, b) => a.year - b.year,
  },
  {
    title: "稿件数量",
    dataIndex: "strawNum",
    align: "center",
    sorter: (a, b) => a.strawNum - b.strawNum,
  },
  {
    title: "出版周期总长",
    dataIndex: "sumTime",
    align: "center",
    sorter: (a, b) => a.sumTime - b.sumTime,
  },
  {
    title: "最长出版周期",
    dataIndex: "maxTime",
    align: "center",
    sorter: (a, b) => a.maxTime - b.maxTime,
  },
  {
    title: "最短出版周期",
    dataIndex: "minTime",
    align: "center",
    sorter: (a, b) => a.minTime - b.minTime,
  },
  {
    title: "平均出版周期",
    dataIndex: "averageTime",
    align: "center",
    sorter: (a, b) => a.averageTime - b.averageTime,
  },
];

const yearcolumns = [
  {
    title: "期次",
    dataIndex: "qici",
    align: "center",
    sorter: (a, b) => a.qici - b.qici,
  },
  {
    title: "稿件数量",
    dataIndex: "strawNum",
    align: "center",
    sorter: (a, b) => a.strawNum - b.strawNum,
  },
  {
    title: "出版周期总长",
    dataIndex: "sumTime",
    align: "center",
    sorter: (a, b) => a.sumTime - b.sumTime,
  },
  {
    title: "最长出版周期",
    dataIndex: "maxTime",
    align: "center",
    sorter: (a, b) => a.maxTime - b.maxTime,
  },
  {
    title: "最短出版周期",
    dataIndex: "minTime",
    align: "center",
    sorter: (a, b) => a.minTime - b.minTime,
  },
  {
    title: "平均出版周期",
    dataIndex: "averageTime",
    align: "center",
    sorter: (a, b) => a.averageTime - b.averageTime,
  },
];
const data = [];
import qs from "qs";

export default {
  data() {
    return {
      data,
      editorialcolumns,
      operateCode: "0",
      sort: "1",
      yearLeft: "",
      yearRight: "",
      year: "",
      groupType: "pi.year",
      yearcolumns,
      total: 0,
      page: 1,
      limit: 20,
      selectedRowKeys: [],
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
    };
  },
  name: "workSet",
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        columnWidth: 35,
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        onSelection: this.onSelection,
      };
    },
  },
  methods: {
    operateChange() {
      if (this.operateCode != "0") {
        var itemLegth = this.selectedRowKeys.length;
        if (itemLegth == 0) {
          this.utils.messageInfo(this, "error", "最少选择一条数据！");
          return;
        }
      }
      if (this.operateCode == "1") {
        if (this.groupType == "pi.year") {
          var jsonDataYear = [];
          for (var i = 0; i < this.data.length; i++) {
            for (var j = 0; j < this.selectedRowKeys.length; j++) {
              if (this.data[i].uId == this.selectedRowKeys[j]) {
                var jsonYear = {
                  year: this.data[i].year,
                  strawNum: this.data[i].strawNum,
                  sumTime: this.data[i].sumTime,
                  maxTime: this.data[i].maxTime,
                  minTime: this.data[i].minTime,
                  averageTime: this.data[i].averageTime,
                };
                jsonDataYear.push(jsonYear);
              }
            }
          }
          exportByYear(jsonDataYear);
        } else if (this.groupType == "pi.count") {
          var jsonDataCount = [];
          for (var n = 0; n < this.data.length; n++) {
            for (var m = 0; m < this.selectedRowKeys.length; m++) {
              if (this.data[n].uId == this.selectedRowKeys[m]) {
                var jsonCount = {
                  qici: this.data[n].qici,
                  strawNum: this.data[n].strawNum,
                  sumTime: this.data[n].sumTime,
                  maxTime: this.data[n].maxTime,
                  minTime: this.data[n].minTime,
                  averageTime: this.data[n].averageTime,
                };
                jsonDataCount.push(jsonCount);
              }
            }
          }
          exportByCount(jsonDataCount);
        }
      }
    },
    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.limit = pageSize;
      this.query();
    },
    tabChange(key) {
      this.yearLeft = "";
      this.yearRight = "";
      this.year = "";
      this.operateCode = "0";
      if (key == 1) {
        this.groupType = "pi.year";
      } else if (key == 2) {
        this.groupType = "pi.count";
      }

      this.query();
    },
    pageChange(pageNumber) {
      this.page = pageNumber;
      this.query();
    },
    //选择全选对勾
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    query() {
      this.axios
        .get("/statistical/publishCycle", {
          params: {
            yearLeft: this.yearLeft,
            yearRight: this.yearRight,
            year: this.year,
            groupType: this.groupType,
            status: 4,
            page: this.page,
            limit: this.limit,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.total = res.data.count;
            this.data = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询稿件列表失败！");
          }
        });
    },
  },
  created() {
    this.query();
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 290;
    var bottom = document.getElementById("bottom");
    var bottom2 = document.getElementById("bottom2");
    bottom.style.height = bottom_height + "px";
    bottom2.style.height = bottom_height + "px";
    this.table_height = bottom_height - 160;
  },
};

function exportByYear(jsonData) {
  //列标题，逗号隔开，每一个逗号就是隔开一个单元格
  let str = `年份,稿件数量,出版周期总长,最长出版周期,最短出版周期,平均出版周期\n`;
  //增加\t为了不让表格显示科学计数法或者其他格式
  for (let i = 0; i < jsonData.length; i++) {
    for (let item in jsonData[i]) {
      str += `${jsonData[i][item] + "\t"},`;
    }
    str += "\n";
  }
  //encodeURIComponent解决中文乱码
  let uri = "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(str);
  //通过创建a标签实现
  let link = document.createElement("a");
  link.href = uri;
  //对下载的文件命名
  link.download = "出版周期统计.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function exportByCount(jsonData) {
  //列标题，逗号隔开，每一个逗号就是隔开一个单元格
  let str = `期次,稿件数量,出版周期总长,最长出版周期,最短出版周期,平均出版周期\n`;
  //增加\t为了不让表格显示科学计数法或者其他格式
  for (let i = 0; i < jsonData.length; i++) {
    for (let item in jsonData[i]) {
      str += `${jsonData[i][item] + "\t"},`;
    }
    str += "\n";
  }
  //encodeURIComponent解决中文乱码
  let uri = "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(str);
  //通过创建a标签实现
  let link = document.createElement("a");
  link.href = uri;
  //对下载的文件命名
  link.download = "出版周期统计.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
</script>

<style>
@import "../../../assets/css/PageCss.css";
</style>

